import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchUserDriveSchool = createAsyncThunk(
  "user/getUserDriveSchool",
  async ({ page = 1, limit = 8, searchQuery = "" }) => {
    try {
      const response = await axiosInstance.get("/user/getUserDriveSchool", {
        params: {
          page,
          limit,
          value: searchQuery,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const activeUserGuest = createAsyncThunk(
  "activeUserGuest/activeGuest",
  async (data) => {
    try {
      const response = await axiosInstance.post(
        "/payments/activeGuestFromUser",
        data
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const getMovmentDriveSchool = createAsyncThunk(
  "getMovmentDriveSchool/getUser",
  async ({ page = 1, limit = 8, searchQuery = "", statusFilter = "" }) => {
    try {
      const response = await axiosInstance.get(
        "/payments/getMovmentDriveSchool",
        {
          params: {
            page,
            limit,
            value: searchQuery,
            statusFilter,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const getDebtDriveSchool = createAsyncThunk(
  "getDebtDriveSchool",
  async () => {
    try {
      const response = await axiosInstance.get("/debt/getDebtDriveSchool");
      console.log(response.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const refusePaymentWithCash = createAsyncThunk(
  "deletePayment/deleteUser",
  async ({ catId, packageId, userId, paymentId }) => {
    try {
      const response = await axiosInstance.post(
        `/payments/refuseUserPayment/${catId}/${packageId}/${userId}/${paymentId}`
      );
      return response.data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        throw new Error(error.response.data.message);
      } else {
        throw new Error("An error occurred while processing the request.");
      }
    }
  }
);

export const refusePaymentWithCashTwo = createAsyncThunk(
  "payments/refuseUserPaymentAdmin",
  async ({ paymentId, catId, packageId }) => {
    try {
      const response = await axiosInstance.post(
        `payments/refuseUserPaymentAdmin/${paymentId}/${catId}/${packageId}`
      );
      return response.data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        throw new Error(error.response.data.message);
      } else {
        throw new Error("An error occurred while processing the request.");
      }
    }
  }
);

const userdriveschoolSlice = createSlice({
  name: "userdriveschool",
  initialState: {
    data: [],
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    loading: false,
    error: null,
    dataMovment: [],
    loadingMovment: false,
    errorDataMovment: null,
    debt: [],
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(refusePaymentWithCash.fulfilled, (state) => {
        state.loading = !state.loading;
      })
      .addCase(refusePaymentWithCashTwo.fulfilled, (state) => {
        state.loading = !state.loading;
      })
      .addCase(getDebtDriveSchool.fulfilled, (state, action) => {
        state.debt = action.payload;
      })
      .addCase(fetchUserDriveSchool.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserDriveSchool.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.totalPages = action.payload.totalPages;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(fetchUserDriveSchool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(activeUserGuest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(activeUserGuest.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(activeUserGuest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getMovmentDriveSchool.pending, (state) => {
        state.loadingMovment = true;
        state.errorDataMovment = null;
      })
      .addCase(getMovmentDriveSchool.fulfilled, (state, action) => {
        state.loadingMovment = false;
        state.dataMovment = action.payload;
        state.totalPages = action.payload.totalPages;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(getMovmentDriveSchool.rejected, (state, action) => {
        state.loadingMovment = false;
        state.errorDataMovment = action.error.message;
      });
  },
});

export const { setPage } = userdriveschoolSlice.actions;

export const selectUserDriveSchool = (state) => state.userDriveSchoolSlice.data;
export const selectDataMovment = (state) =>
  state.userDriveSchoolSlice.dataMovment;
export default userdriveschoolSlice.reducer;
